export default __webpack_public_path__ + "static/media/search-fnb-new.f7a26ab2.svg";